import { useMount } from 'shared/src/hooks';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewSignIn = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useMount(() => {
    logAnalyticsEvent({ name: 'VIEW_SIGN_IN' });
  });
};
